import React, { useState } from 'react';
import CourseResourcePage from './CourseResourcePage';
import CourseResourceDetailPage from './CourseResourceDetailPage';

type CourseResourceHubProps = {
  spaceId: string;
  spaceProductId: string;
};

/** 课程资源产品页：列表与详情切换 */
const CourseResourceHub: React.FC<CourseResourceHubProps> = ({ spaceId, spaceProductId }) => {
  const [courseId, setCourseId] = useState<string | null>(null);

  return (
    <div className="course-resource-root">
      {courseId ? (
        <CourseResourceDetailPage
          spaceId={spaceId}
          spaceProductId={spaceProductId}
          courseId={courseId}
          onBack={() => setCourseId(null)}
        />
      ) : (
        <CourseResourcePage
          spaceId={spaceId}
          spaceProductId={spaceProductId}
          onOpenCourse={setCourseId}
        />
      )}
    </div>
  );
};

export default CourseResourceHub;
